import benifitImage from "../../assets/benefits/customer_benefits_v6.png";
// import benifitImage from "../../assets/benefits/Rectangle2.png";
import Header from "../../common/Header";
import { shareURL } from "../../config/axiosAuth";
import { ShareVisaLancerLink } from "../../services/services";
import styles from "./benifit.module.css";



const BenifitPage = () => {
  const user_id = localStorage.getItem("userId");
  const session_id = localStorage.getItem("session_id");

  const callShareVisaeroLink = async () => {
    try {
      const request = await ShareVisaLancerLink(user_id, session_id);
      const response = await request.data;
      if (response.status == 1) {
        let url = `${shareURL}/visa-lancer?visa_lancer_code=${response?.data?.visa_lancer_code}`;
        return url;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShare = async () => {
    const URL = await callShareVisaeroLink();
    const imageURL = process.env.PUBLIC_URL + "/assets/customer_benefits_v6.png"; //  "/assets/customer_benefits.png"
    const imageBlob = await fetch(imageURL).then((response) => response.blob());

    if (!URL) return;
    if (navigator.share) {
      await navigator
        .share({
          title: "Share & Earn",
          url: URL,
          // text: SHARE_TEXT,
          files: [new File([imageBlob], "image.png", { type: "image/jpeg" })],
        })
        .then(() => {
          // console.log("Thanks for sharing!");
        })
        .catch(console.error);
    }
  };
  return (
    <>
      <div className={styles.container}>
        <Header header="Customer Benefits" />

        <div className={styles.share_container}>
          <img
            src={benifitImage}
            className={styles.share_img}
            alt="Customer Benefits"
          />
        </div>
        <div className={styles.footerSection}>
          <button className={styles.btn} onClick={handleShare}>
            Share
          </button>
        </div>
      </div>
    </>
  );
};

export default BenifitPage;
